import React from 'react';
import PropTypes from 'prop-types';
import storeStyle from '../style.module.less';

const StoreLogoImage = ({ imageUrl }) => {
  return (
    <div className={storeStyle.image}>
      <img alt='store-branding-logo' src={imageUrl} />
    </div>
  );
};

StoreLogoImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};

export default StoreLogoImage;
